module.exports = __webpack_public_path__ + "static/Logo-f53723a06daad40c8c0c694b253cbe8f.png";